import { Create, Default, Detail, List } from "./views";
import MediaDownload from "./views/MediaDownload/Default";



const Module = {
    name: "documents",
    defaultRoutePath: "/documents/document",
    menuItemScope: "documents",
    menuItemName: "documents",

    routes: [
        {
            path: "/documents/document",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
        {
            path: "/documents/media/:id",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: MediaDownload,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        {
            path: "create",
            Component: Create,
        }
        
    ],
   
}

export default Module;
